import { Controller } from '@hotwired/stimulus'

/**
 * Initializes [copy] buttons in copy_code.html.erb (or anywhere)
 */
export default class extends Controller {
    static targets = ['btn', 'code', 'formatted']

    declare readonly btnTarget: HTMLElement
    declare readonly codeTarget: HTMLElement
    declare readonly formattedTarget: HTMLElement
    declare readonly hasFormattedTarget: boolean

    copy() {
        navigator.clipboard.writeText(this.codeTarget.innerText)
        if (this.hasFormattedTarget) this.formattedTarget.classList.add('opacity-50')
        const originalText = this.btnTarget.innerText
        this.btnTarget.innerText = 'Copied!'
        setTimeout(() => {
            this.btnTarget.innerText = originalText
            if (this.hasFormattedTarget) this.formattedTarget.classList.remove('opacity-50')
        }, 500)
    }
}
